export default __webpack_public_path__ + "static/media/HoloLens-MDL2-Assets.323ac9e8.TTF";